import {
  isJobCategory,
  type JobCategory,
} from "@/domains/job-offer/create/constants";

/**
 * The Phosphor icon class of each job category, from the prototype
 * («Morph», now deleted). The backend tree has no
 * icons, so the map lives here. OQ4: it is updated by hand when the 8
 * categories change.
 */
export const CATEGORY_ICON: Record<JobCategory, string> = {
  "Web Mobile & Software Dev": "ph-code",
  "Design & Creative": "ph-palette",
  "Sales & Marketing": "ph-megaphone",
  Writing: "ph-pen-nib",
  "Accounting & Consulting": "ph-scales",
  "Data Science & Analytics": "ph-chart-line-up",
  "Engineering & Architecture": "ph-compass-tool",
  "Customer Service": "ph-headset",
};

const FALLBACK_ICON = "ph-briefcase";

/** The icon class of a category key; `ph-briefcase` for a key outside the 8. */
export function categoryIconClass(key: string): string {
  return isJobCategory(key) ? CATEGORY_ICON[key] : FALLBACK_ICON;
}
